import React from "react";
import { FaMagic } from "react-icons/fa";
import "../../../assets/scss/components/_usage-credits-card.scss";

interface IProps {
    onUpgradeClick?: () => void;
}

const CreditsBanner: React.FC<IProps> = ({ onUpgradeClick }) => {
    return (
        <div className="credits-banner-v2">
            <div className="credits-banner-v2__content">
                <div className="credits-banner-v2__icon">
                    <FaMagic size={24} color="#ffffff" />
                </div>
                <div className="credits-banner-v2__text">
                    <h4>Need more credits?</h4>
                    <p>Upgrade to Growth for 10x more searches and unlimited AI recommendations.</p>
                </div>
            </div>
            <button className="credits-banner-v2__cta" onClick={onUpgradeClick}>
                View Plans
            </button>
        </div>
    );
};

export default CreditsBanner;
